import { APIService } from "@/config/api-service-client.js";
import router from "@/router";

const PATH = `/atu-entity`;

const getDefaultState = () => {
  return {
    entitiesList: {
      content: [],
      pagination: null,
    },
    entitiesListParams: {
      pagination: {
        pageSize: 10,
        currentPage: 1,
      },
      searchText: "",
      tableSorting: {
        sortType: "",
        sortTypeOrder: "",
      },
    },
    activeEntity: null,
    entityModalVissible: false,
  };
};

export default {
  state: getDefaultState(),
  mutations: {
    RESET_ENTITIES_STATE(state) {
      Object.assign(state, getDefaultState());
    },
    MUTATE_ENTITIES(state, val) {
      const { content, ...rest } = val;
      state.entitiesList.content = content;
      state.entitiesList.pagination = rest;
    },
    MUTATE_ENTITIES_LIST_PARAMS(state, val) {
      state.entitiesListParams = val;
    },
    MUTATE_ACTIVE_ENTITY(state, val) {
      state.activeEntity = val;
    },
    MUTATE_ENTITY_MODAL_VISSIBLE(state, val) {
      state.entityModalVissible = val;
    },
  },
  actions: {
    async fetchEntities(ctx) {
      const params = ctx.state.entitiesListParams;
      const sortType = params.tableSorting.sortType;
      const sortTypeOrder = params.tableSorting.sortTypeOrder;
      const page = params.pagination.currentPage - 1;
      const size = params.pagination.pageSize;
      const searchText = params.searchText;

      let path = `${PATH}?sort=${sortType},${sortTypeOrder}&page=${page}&size=${size}`;
      if (searchText) {
        path = `${path}&key=${searchText}`;
      }

      try {
        const resp = await APIService.get(path);
        ctx.commit("MUTATE_ENTITIES", resp);
        return resp;
      } catch (e) {
        console.log(e);
        throw e;
      }
    },
    async createEntity(ctx, form) {
      try {
        const resp = await APIService.post(`${PATH}`, {
          ...form,
        });
        ctx.dispatch("fetchEntities");
        return resp;
      } catch (e) {
        console.log(e);
        throw e;
      }
    },
    async editEntity(ctx, data) {
      const { id, ...rest } = data;
      try {
        const resp = await APIService.put(`${PATH}/${id}`, {
          ...rest,
        });
        ctx.dispatch("fetchEntities");
        return resp;
      } catch (e) {
        console.log(e);
        throw e;
      }
    },
    async deleteEntity(ctx, id) {
      try {
        await APIService.delete(`${PATH}/${id}`);
        ctx.dispatch("fetchEntities");
      } catch (e) {
        console.log(e);
        throw e;
      }
    },
    async fetchEntityByID(ctx, id) {
      try {
        const resp = await APIService.get(`${PATH}/${id}`);
        ctx.commit("MUTATE_ACTIVE_ENTITY", resp);
        return resp;
      } catch (e) {
        if (e?.response?.status === 400)
          router.replace({ name: "PageEntities" });
        console.log(e);
        throw e;
      }
    },
  },
  getters: {
    getEntitiesList: (state) => state.entitiesList,
    getEntitiesListParams: (state) => state.entitiesListParams,
    getActiveEntity: (state) => state.activeEntity,
    getEntityModalVissible: (state) => state.entityModalVissible,
  },
};
